export default __webpack_public_path__ + "static/media/saas_generic.4051f331.svg";